import { Address } from 'viem';

import { api, cacheTags, IConnectedActionParams } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';
import { asAddress } from 'modules/api/utils/asAddress';
import { getWalletClient } from 'modules/api/walletClient';

import { getPendingUnstakes } from '../methods/getPendingUnstakes';
import { IPoolUnstake } from '../types';

interface IGetPoolArgs extends IConnectedActionParams {
  poolAddresses: Address[];
}

export const EMPTY_POOL_UNSTAKES: IPoolUnstake[] = [];

export const {
  useGetPendingUnstakesQuery,
  endpoints: { getPendingUnstakes: getPendingUnstakesEndpoint },
} = api.injectEndpoints({
  endpoints: build => ({
    getPendingUnstakes: build.query<IPoolUnstake[], IGetPoolArgs>({
      queryFn: async ({ poolAddresses }) => {
        const publicClient = getPublicClient();
        const walletClient = getWalletClient();

        return {
          data: await getPendingUnstakes(publicClient, {
            poolAddresses,
            accountAddress: asAddress(walletClient.account?.address),
          }),
        };
      },
      providesTags: [cacheTags.account, cacheTags.unstake, cacheTags.claim],
    }),
  }),
});
